export default [
  {
    value: {
      width: 1280,
      height: 720
    },
    key: 1,
    label: '1280 X 720'
  },
  {
    value: {
      width: 720,
      height: 1280
    },
    key: 2,
    label: '720 X 1280'
  },
  {
    value: {
      width: 960,
      height: 540
    },
    key: 3,
    label: '960 X 540'
  },
  {
    value: {
      width: 750,
      height: 1334
    },
    key: 4,
    label: '750 X 1334'
  },
  {
    value: {
      width: 960,
      height: 334
    },
    key: 5,
    label: '960 X 334'
  },
  {
    value: {
      width: 480,
      height: 320
    },
    key: 6,
    label: '480 X 320'
  },
  {
    value: {
      width: 1080,
      height: 1920
    },
    key: 7,
    label: '1080 X 1920'
  },
  {
    value: {
      width: 960,
      height: 274
    },
    key: 8,
    label: '960 X 274'
  },
  {
    value: {
      width: 1000,
      height: 1000
    },
    key: 9,
    label: '1000 X 1000'
  },
  {
    value: {
      width: 480,
      height: 270
    },
    key: 10,
    label: '480 X 270'
  },
  {
    value: {
      width: 147,
      height: 147
    },
    key: 11,
    label: '147 X 147'
  },
  {
    value: {
      width: 1140,
      height: 640
    },
    key: 12,
    label: '1140 X 640'
  },
  {
    value: {
      width: 640,
      height: 360
    },
    key: 13,
    label: '640 X 360'
  },
  {
    value: {
      width: 800,
      height: 800
    },
    key: 14,
    label: '800 X 800'
  },
  {
    value: {
      width: 1920,
      height: 1080
    },
    key: 15,
    label: '1920 X 1080'
  }
]
